export function formattedNameWithDOB(
  birthDate: string,
  firstName: string,
  lastName?: string,
): string {
  return `${firstName} ${lastName ? lastName : ''} (${birthDate})`;
}

/**
 * Replaces '\n' tag in message to <br /> tag
 * @param {string} message
 * @returns converted message
 */
export function replaceLineToBreakTag(message: string): string {
  return message.replace(/\n/g, '<br />');
}

/**
 * Format date to MM/DD/YYYY format
 * @param {Date} date
 * @returns date in MM/DD/YYYY format
 */
export function formatDateAsMDY(date: Date): string {
  const lengthOfDate = 2;
  const dd = String(date.getDate()).padStart(lengthOfDate, '0');
  const mm = String(date.getMonth() + 1).padStart(lengthOfDate, '0'); // January is 0
  const yyyy = date.getFullYear();

  return `${mm}/${dd}/${yyyy}`;
}

export function addRemoveScrollClassFromBody(isOpen: boolean): void {
  if (isOpen) {
    document.body.classList.add('HideScroll');
  } else {
    document.body.classList.remove('HideScroll');
  }
}

//  Used type as any because formValue can contain any object with any key
export const createFilterString = (formValue: any) =>
  Object.keys(formValue)
    .filter((key) => !!formValue[key])
    .map((key) => formValue[key])
    .join(', ');
